/*
 * @Author: 欧阳铭山
 * @Date: 2022-06-21 14:42:28
 * @LastEditors: 欧阳铭山
 * @LastEditTime: 2022-07-14 19:40:11
 * @Description: Description
 * @FilePath: \qiankun-master\examples\vue\src\public-path.js
 */
if (window.__POWERED_BY_QIANKUN__) {
  // eslint-disable-next-line no-undef
  __webpack_public_path__ = window.__INJECTED_PUBLIC_PATH_BY_QIANKUN__;
  //console.log(1,window.__INJECTED_PUBLIC_PATH_BY_QIANKUN__)
}
